import actions from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';

const DEFAULT_YEARLY_REJECTED = false;

export default Backbone.Model.extend({
    silentChange: false,
    connect: true,
    selectors: ['primeMemberSelected'],
    default: {
        binNumber: '',
        offerId: '',
        isRestricted: false,
    },
    dataUrl: 'isbankaccountrestrictedforsubscription',
    url() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(this.dataUrl);
    },
    initialize() {
        this.listenTo(this, 'change:binNumber', this.onBinNumberChange);
        this.listenTo(this, 'change:isRestricted', this.onRestrictedChange);
        dispatch({type: actions.SET_YEARLY_REJECTED, entry: DEFAULT_YEARLY_REJECTED});
    },
    onRestrictedChange() {
        Odigeo.trigger('yearly-rejected-cards:yearlyRejectedChange', this.get('isRestricted'), this.get('binNumber'));
    },
    onBinNumberChange() {
        const {isSubscriptionAdded} = this.get('primeMemberSelected');
        if (isSubscriptionAdded) {
            this.fetch({
                url: this.url(),
                data: JSON.stringify({
                    binNumber: this.get('binNumber'),
                    offerId: this.get('offerId'),
                }),
                contentType: 'application/json',
                type: 'POST',
                dataType: 'json',
                success: (model, isRestricted) => {
                    this.set({isRestricted});
                    dispatch({type: actions.SET_YEARLY_REJECTED, entry: isRestricted});
                },
                error: () => {
                    this.set({isRestricted: false});
                    dispatch({type: actions.SET_YEARLY_REJECTED, entry: DEFAULT_YEARLY_REJECTED});
                },
            });
        }
    },
});
